import { render, staticRenderFns } from "./Founder.vue?vue&type=template&id=df80f4a6&scoped=true&"
import script from "./Founder.vue?vue&type=script&lang=ts&"
export * from "./Founder.vue?vue&type=script&lang=ts&"
import style0 from "./Founder.vue?vue&type=style&index=0&id=df80f4a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df80f4a6",
  null
  
)

export default component.exports